import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenPopup } from '#action/project/users-popup';
import UserPopup from '#component/user/popup';
import { CountButton } from './styles';

const UsersCountListButton = ({ project }) => {
  const dispatch = useDispatch();
  const [openUserPopup, setOpenUserPopup] = useState(false);
  const count = project.users;

  const handleOpenUserPopup = () => {
    setOpenUserPopup(!openUserPopup);
    dispatch(setOpenPopup(!openUserPopup));
  };

  if (!count) {
    return null;
  }

  return (
    <>
      <CountButton
        onClick={handleOpenUserPopup}
        aria-label="Show all"
      >
        {count}
      </CountButton>
      {(openUserPopup) &&
        <UserPopup
          project={project}
          open={openUserPopup}
          openedFromCreateForm={false}
          handleClose={handleOpenUserPopup}
        />}
    </>
  );
};

export default UsersCountListButton;
